module.exports = __webpack_public_path__ + "static/media/previousGreyArrow.b0fb71c1.svg";